import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × TAG HEUER: Temporal precision
// Chrono subdials, angular metallic patterns, grid timing
export function VasarelyTagheuerMode({ brand }: ModeRendererProps) {
  const tagRed = "#E31E24";
  const tagSilver = "#C0C0C0";

  return (
    <g>
      {/* Metallic background */}
      <defs>
        <linearGradient id="tagheuer-metal" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#2A2A2A" />
          <stop offset="50%" stopColor="#3C3C3C" />
          <stop offset="100%" stopColor="#2A2A2A" />
        </linearGradient>
      </defs>

      <rect x="0" y="0" width="794" height="1123" fill="url(#tagheuer-metal)" />

      <g transform="translate(397 540)">
        {/* Chrono subdials (three counters) */}
        {[
          { x: 0, y: -140, label: "1/10" },
          { x: -120, y: 70, label: "MIN" },
          { x: 120, y: 70, label: "SEC" },
        ].map((dial, i) => (
          <g key={i}>
            <circle cx={dial.x} cy={dial.y} r="55" fill="#1A1A1A" opacity="0.8" />
            <circle cx={dial.x} cy={dial.y} r="55" fill="none" stroke={tagSilver} strokeWidth="3" opacity="0.7" />
            
            {/* Subdial markers */}
            {Array.from({ length: 12 }).map((_, k) => {
              const angle = (k * Math.PI * 2) / 12;
              const r1 = 45;
              const r2 = 50;
              
              return (
                <line
                  key={k}
                  x1={dial.x + Math.cos(angle) * r1}
                  y1={dial.y + Math.sin(angle) * r1}
                  x2={dial.x + Math.cos(angle) * r2}
                  y2={dial.y + Math.sin(angle) * r2}
                  stroke={tagSilver}
                  strokeWidth="1.5"
                  opacity="0.6"
                />
              );
            })}
            
            <text
              x={dial.x}
              y={dial.y + 4}
              textAnchor="middle"
              fontFamily="monospace"
              fontSize="9"
              fill={tagSilver}
              opacity="0.7"
            >
              {dial.label}
            </text>
          </g>
        ))}

        {/* Angular metallic grid */}
        {Array.from({ length: 16 }).map((_, i) => {
          const angle = (i * Math.PI) / 8;
          return (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(angle) * 260}
              y2={Math.sin(angle) * 260}
              stroke={tagSilver}
              strokeWidth="1"
              opacity="0.2"
            />
          );
        })}

        {/* Grid timing markers */}
        {Array.from({ length: 60 }).map((_, i) => {
          const angle = (i * Math.PI * 2) / 60;
          const isMinute = i % 5 === 0;
          const r1 = isMinute ? 200 : 210;
          const r2 = 230;
          
          return (
            <line
              key={i}
              x1={Math.cos(angle) * r1}
              y1={Math.sin(angle) * r1}
              x2={Math.cos(angle) * r2}
              y2={Math.sin(angle) * r2}
              stroke={tagRed}
              strokeWidth={isMinute ? 3 : 1}
              opacity={isMinute ? 0.8 : 0.4}
            />
          );
        })}

        {/* Precision circles */}
        {Array.from({ length: 12 }).map((_, i) => {
          const r = 60 + i * 16;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={tagSilver}
              strokeWidth="1"
              opacity={0.25 - i * 0.015}
            />
          );
        })}

        {/* Speed nodes */}
        {[0, 45, 90, 135, 180, 225, 270, 315].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 180;
          
          return (
            <g key={angle}>
              <polygon
                points={`
                  ${Math.cos(rad) * r},${Math.sin(rad) * r - 10}
                  ${Math.cos(rad) * r - 8},${Math.sin(rad) * r + 10}
                  ${Math.cos(rad) * r + 8},${Math.sin(rad) * r + 10}
                `}
                fill={tagRed}
                opacity="0.7"
              />
            </g>
          );
        })}

        {/* Central bezel */}
        <circle cx="0" cy="0" r="50" fill="#1A1A1A" opacity="0.9" />
        <circle cx="0" cy="0" r="50" fill="none" stroke={tagRed} strokeWidth="3" opacity="0.8" />
        <circle cx="0" cy="0" r="45" fill="none" stroke={tagSilver} strokeWidth="1" opacity="0.6" />
      </g>

      {/* Tag Heuer text */}
      <text x="397" y="1025" textAnchor="middle" fontFamily="sans-serif" fontWeight="700" fontSize="12" fill={tagRed} opacity="0.8">
        PRÉCISION TEMPORELLE
      </text>
    </g>
  );
}
